import { mutatorAction } from "satcheljs";
import { shiftRequestsPanelStore } from "../";

export default mutatorAction('SET_SHOW_CREATE_REQUEST_DIALOG_IN_STORE', function setShowCreateRequestDialogInStore(visible: boolean) {
    shiftRequestsPanelStore().showCreateRequestDialog = visible;
});
